import { DataListCard } from '~/components/DataList';
import { useStoreContext } from '~/providers/StoreProvider';

// Dolly links each store to its channel, with this database as the source of truth
export function SlackCard() {
  const { sharedSlackChannelId } = useStoreContext();

  return (
    <DataListCard
      title="Shared Slack Channel"
      items={[
        {
          label: 'Channel ID',
          value: sharedSlackChannelId ?? 'No channel linked',
          copyEnabled: !!sharedSlackChannelId,
        },
      ]}
    />
  );
}
